export default __webpack_public_path__ + "static/media/logo6.98c7572f.png";